import styled from 'styled-components';

export const SettingsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
  gap: 1px;
  margin: 4px 0 0 0;
`;
